import React, {useEffect} from 'react';

import {DelayRender} from './DelayRender';
import {type GraphNotices} from './graphRenderProps';

function noop() {}

/** The layout mounts this leaf only when the delayed warning is visible. */
export function DelayedMetricsNotice({
  notices,
}: {
  notices: Pick<GraphNotices, 'onDelayedNoticeShown' | 'onLoadAnyway'>;
}) {
  const onDelayedNoticeShown = notices.onDelayedNoticeShown;
  useEffect(
    function reportDelayedNoticeShown() {
      onDelayedNoticeShown?.();
    },
    [onDelayedNoticeShown]
  );
  return <DelayRender onLoadAnyway={notices.onLoadAnyway ?? noop} />;
}
